export default __webpack_public_path__ + "static/media/top_grey-gorizontal.b82e9de7.svg";